export const COLORS = {
    orchid_blue: '#47719D',
    orchid_teal: '#27567B',
    orchid_indigo: '#444A9F',
    orchid_dark: '#2B2D42',
    black: '#1D1E2C',
    light_gray: '#8D99AE',
}